export default "__VITE_ASSET__DKWrSTVM__"